<ng-container *ngIf="lang === 'en'">
  <ng-content select="[forEn]"></ng-content>
</ng-container>

<ng-container *ngIf="lang === 'ko'">
  <ng-content select="[forKo]"></ng-content>
</ng-container>
